export default function CheckboxControl({ id, name, label, checked, onChange }) {
  return (
    <div className="checkbox-control">
      <input id={id} className="checkbox" type="checkbox" name={name} checked={checked} onChange={onChange} />
      <label htmlFor={id}>
        <span className="checkbox-icon flex" style={{ color: 'inherit' }}>
          <span className="checkbox-icon-selected">
            <svg
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="icon icon-forte-forte-checkbox-selected"
              width="16"
            >
              <rect x="6" y="6" width="4" height="4" fill="currentColor"></rect>
              <rect x="0.5" y="0.5" width="15" height="15" stroke="currentColor"></rect>
            </svg>
          </span>
          <span className="checkbox-icon-not-selected">
            <svg
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="icon icon-forte-forte-checkbox"
              width="16"
            >
              <rect x="0.5" y="0.5" width="15" height="15" stroke="currentColor"></rect>
            </svg>
          </span>
        </span>
        <span className="checkbox-label">{label}</span>
      </label>
    </div>
  );
}
